import { apiClient } from './authService';

const basePath = '/action-items/';

const actionItemService = {
  list: async (params = {}) => (
    await apiClient.get(basePath, { params })
  ).data,
  filterOptions: async () => (
    await apiClient.get(`${basePath}filter-options/`)
  ).data,
  get: async (id) => (
    await apiClient.get(`${basePath}${id}/`)
  ).data,
  create: async (payload) => (
    await apiClient.post(basePath, payload)
  ).data,
  listComments: async (id, page = 1) => (
    await apiClient.get(
      `${basePath}${id}/comments/`,
      { params: { page } },
    )
  ).data,
  addComment: async (id, body) => (
    await apiClient.post(`${basePath}${id}/comments/`, { body })
  ).data,
  updateDueDate: async (id, due_date) => (
    await apiClient.patch(`${basePath}${id}/`, { due_date })
  ).data,
  approve: async (id, comment = '') => (
    await apiClient.post(`${basePath}${id}/approve/`, { comment })
  ).data,
  disapprove: async (id, comment = '') => (
    await apiClient.post(`${basePath}${id}/disapprove/`, { comment })
  ).data,
  advance: async (id) => (
    await apiClient.post(`${basePath}${id}/advance/`)
  ).data,
  cancel: async (id, note = '') => (
    await apiClient.post(`${basePath}${id}/cancel/`, { note })
  ).data,
  managerOptions: async (centre) => (
    await apiClient.get(
      `${basePath}manager-options/`,
      { params: { centre } },
    )
  ).data,
  formOptions: async (centre) => (
    await apiClient.get(
      `${basePath}form-options/`,
      { params: { centre } },
    )
  ).data,
};

export default actionItemService;
